import React from "react";
import { CheckIcon, XIcon } from "./icons";

interface ComparisonRow {
  feature: string;
  generic: string;
  gymea: string;
}

const COMPARISON_ROWS: ComparisonRow[] = [
  {
    feature: "Compliance",
    generic:
      "Not pre-loaded with NSW, VIC or Australian curriculum content, sometimes leading to incorrect or 'hallucinated' codes.",
    gymea:
      "An AI lesson generator designed around NSW, VIC & Australian curriculum requirements.",
  },
  {
    feature: "Workflow",
    generic: "Type out all the information and your request manually.",
    gymea: "Easy tick-and-fill form with curriculum knowledge pre-loaded.",
  },
  {
    feature: "Consistency",
    generic:
      "Inconsistent structure for units of work, lesson structures or support plans.",
    gymea: "Standardised templates across your faculty.",
  },
  {
    feature: "Output",
    generic:
      "Raw text you copy-paste, format into templates, and find curriculum info yourself.",
    gymea:
      "Fully formatted, curriculum-aligned plans ready to edit and use, with automatic slideshow generation for lesson plans.",
  },
];

export const ComparisonSection: React.FC = () => (
  <section className="comparison-section">
    <div className="comparison-content">
      <h2 className="comparison-title">Why not just use ChatGPT?</h2>
      <p className="comparison-subtitle">
        Generic AI is great at generating paragraphs. Gymea Edu is a structured
        AI lesson planner built for Australian compliance.
      </p>
      <div className="comparison-table-wrapper">
        <table className="comparison-table">
          <thead>
            <tr>
              <th className="comparison-feature-header">Feature</th>
              <th className="comparison-generic-header">Generic AI</th>
              <th className="comparison-gymea-header">Gymea Edu</th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row) => (
              <tr key={row.feature}>
                <td className="comparison-feature-cell">{row.feature}</td>
                <td className="comparison-generic-cell">
                  <span className="comparison-icon comparison-icon-x">
                    <XIcon />
                  </span>
                  {row.generic}
                </td>
                <td className="comparison-gymea-cell">
                  <span className="comparison-icon comparison-icon-check">
                    <CheckIcon />
                  </span>
                  {row.gymea}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);
